export default __webpack_public_path__ + "static/media/BASAVARAJ_MULWAD_SCIENCE.90abded4.JPG";